// components/CreateActionDialog.tsx

import { Dialog } from '@/presentation/components/Dialog';
import { DialogHeader } from '@/presentation/components/Dialog/DialogHeader';
import { DialogBody } from '@/presentation/components/Dialog/DialogBody';


interface CreateDialogProps {
  open: boolean;
  title: string;
  width?: "sm" | "md" | "lg" | "xl";
  children: React.ReactNode;
  onClose: () => void;
}

export function CreateDialog({
  open,
  title,
  width = "lg",
  children,
  onClose,
}: CreateDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      width={width}
    >
      <DialogHeader>
        {title}
      </DialogHeader>

      <DialogBody>
        {children}
      </DialogBody>
    </Dialog>
  );
}